import { useTranslation } from 'react-i18next'
import { useTenantConfig } from '../../context/TenantConfigContext'
import './HomeTestimonials.css'

function HomeTestimonials() {
  const { t } = useTranslation()
  const { testimonials, getComponentKey } = useTenantConfig()
  const isList = getComponentKey('reviews') === 'reviews-list'

  if (!testimonials?.length) return null

  return (
    <section
      className={`home-testimonials ${isList ? 'home-testimonials--list' : 'home-testimonials--grid'}`}
      id="home-testimonials"
      aria-labelledby="home-testimonials-title"
    >
      <div className="home-testimonials__inner">
        <div className="home-testimonials__head">
          <span className="home-testimonials__eyebrow">{t('home.testimonials.eyebrow')}</span>
          <h2 id="home-testimonials-title" className="home-testimonials__title">
            {t('home.testimonials.title')}
          </h2>
          <p className="home-testimonials__sub">{t('home.testimonials.subtitle')}</p>
        </div>

        <div className="home-testimonials__items">
          {testimonials.map((item) => (
            <article key={item.id} className="home-testimonials__card">
              <span className="home-testimonials__quote-mark" aria-hidden>
                “
              </span>
              <blockquote className="home-testimonials__quote">{item.comment}</blockquote>
              <footer className="home-testimonials__author">
                <span className="home-testimonials__avatar" aria-hidden>
                  {item.name.charAt(0).toUpperCase()}
                </span>
                <cite className="home-testimonials__name">{item.name}</cite>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HomeTestimonials
